export const pushengage = () => {
    const appId = window.appConfig?.pushengageAppId;
    const theme = window.appConfig?.theme;

    if (!appId && !theme) {
        console.error('PushEngage App ID or Theme is missing');
        return;
    }

    window.PushEngage = window.PushEngage || [];
    window._peq = window._peq || [];

    window.PushEngage.push(['setDevelopmentMode', true]);
    window.PushEngage.push([
        'init',
        {
            appId,
            enableSubscriptionBell: true,
        },
    ]);
    window.PushEngage.push(['showSubscriptionBell']);
    window.PushEngage.push(['setLogLevel', 'debug']);

    const script = document.createElement('script');
    script.src = 'https://clientcdn.pushengage.com/sdks/pushengage-web-sdk.js';
    script.async = true;
    script.type = 'text/javascript';
    document.head.appendChild(script);

    if ('serviceWorker' in navigator) {
        navigator.serviceWorker
            .register(`/${theme}/service-worker.js`)
            .then((registration) => {
                console.log('Service Worker registered:', registration.scope);
            })
            .catch((error) => {
                console.error('Service Worker registration failed:', error);
            });
    }
};
